import {DISCUSSION_API, DELETE_COMMENT_ERROR} from '../../../constants';

export const deleteComment = async ({
    discussionId,
    commentId
}) => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(`${DISCUSSION_API}/${discussionId}/comments/${commentId}`, {
            method: 'PUT',
            headers: new Headers({
                'x-access-token': user.accessToken,
                'Content-Type': 'application/json'
            })
        });
        if (!response.ok) throw response;
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        throw DELETE_COMMENT_ERROR;
    }
};